import React from 'react';

import { View } from 'react-native';

// Props exist only to satisfy the type checker
export const AnimatedOfferItem = ({
  children,
}: React.PropsWithChildren<{ setSkipAnimation: (skip: boolean) => void }>) => {
  return <View>{children}</View>;
};
